import { render, staticRenderFns } from "./stopAllRepliers.vue?vue&type=template&id=3b571084&scoped=true&"
import script from "./stopAllRepliers.vue?vue&type=script&lang=js&"
export * from "./stopAllRepliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b571084",
  null
  
)

export default component.exports